
export const apiUrl = "https://api.murunga.ziz.co.ke/api"
export const socketsApiUrl = "wss://api.murunga.ziz.co.ke"
